// This is just an example,
// so you can safely delete all default props below

export default {
    reset_password: 'Reset Password',
    password: 'Password',
    repeat_password: 'Repeat Password',
    set_password: 'Set Password',
    succeeded: 'Password Reset Success',
    error_password: 'Password must be at least 8 characters long and contain at least one uppercase character one lowercase character and one number',
    error_password_repeat: 'Password repeated must be the same with password',
}
